import './subpage_wrapper.less';

import React, { Component } from 'react';
import classNames from 'classnames';

class SubpageWrapperFullpageTextSection extends Component {

  render() {
    const { cssClassesList, isTemplate, children } = this.props;

    return(
      <div
        className={classNames('subpage-is-fullpage', {
          'page-is-template': isTemplate
        }, cssClassesList)}
      >
        { children }
      </div>
    );
  }
}

export default SubpageWrapperFullpageTextSection;
